exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-bold[data-v-84091ae2]{\n    font-weight: bolder;\n}\n", ""]);

// exports
